import validator from "validator";
import message from "../../../messages/page";
import TypePageConstant from "../../../component/sections/page/TypePageConstant";

const validateTitle = (title) => {
  if (validator.isEmpty(title)) {
    return message.TITLE_DOSE_NOT_EXIST;
  }

  if (!title.trim().length) {
    return message.TITLE_DOSE_NOT_EXIST;
  }

  return true;
};

const validatePattern = (pattern, siteUrl, typePage) => {
  if (validator.isEmpty(pattern)) {
    return message.PATTERN_DOSE_NOT_EXIST;
  }

  if (pattern.charAt(0) != "/") {
    return message.PATTERN_INVALID;
  }

  if (pattern.includes("https://")) {
    return message.PATTERN_INVALID;
  }

  if (!pattern.trim().length) {
    return message.PATTERN_INVALID;
  }

  if (pattern.includes(siteUrl)) {
    return message.PATTERN_INVALID;
  }

  if (typePage == TypePageConstant.typePage.MULTI_PAGE) {
    if (!pattern.includes("@")) {
      return message.PATTERN_INVALID;
    }
  }

  return true;
};

const validateLink = (link, pattern, typePage) => {
  if (validator.isEmpty(link)) {
    return message.LINK_DOSE_NOT_EXIST;
  }

  if (!link.trim().length) {
    return message.LINK_DOSE_NOT_EXIST;
  }

  if (!validator.isURL(link)) {
    return message.LINK_INVALID;
  }

  if (!link.includes("https://")) {
    return message.LINK_INVALID;
  }

  link = decodeURI(link);
  pattern = decodeURI(pattern);
  if (typePage == TypePageConstant.typePage.STATIC) {
    if (!link.includes(pattern)) {
      return message.LINK_INVALID;
    }
  } else {
    pattern = pattern.replace("@s", "");
    if (!link.includes(pattern)) {
      return message.LINK_INVALID;
    }
  }

  return true;
};

const validateImage = (image) => {
  if (Object.keys(image).length) {
    return message.FILE_DOSE_NOT_EXIST;
  }

  if (image.type != "image/webp") {
    return message.FILE_INVALID;
  }

  if (!image.name.includes(".webp")) {
    return message.FILE_INVALID;
  }

  return true;
};

const validateActive = (active) => {
   if (validator.isEmpty(active)) {
    return message.ACTIVE_DOSE_NOT_EXIST;
  }
  return true;
};

const validateFormAddPage = (info, typePage) => {
  const resValidateTitle = validateTitle(info.title);
  if (resValidateTitle != true) {
    return resValidateTitle;
  }
  const resValidatePattern = validatePattern(
    info.pattern,
    info.siteUrl,
    typePage
  );
  if (resValidatePattern != true) {
    return resValidatePattern;
  }

  const resValidateLink = validateLink(info.link, info.pattern, typePage);
  if (resValidateLink != true) {
    return resValidateLink;
  }

  const resValidateActive = validateActive(info.active + "");
  if (resValidateActive != true) {
    return resValidateActive;
  }

  const resValidateImage = validateImage(info.image);
  if (resValidateImage != true) {
    return resValidateImage;
  }

  return true;
};

export default validateFormAddPage;
